import { isNonNullable } from '@ipfabric/utils';
import { maybeProp } from '@ipfabric/utils/fp/prop';
import { makeBoxTree } from 'components/BoxTree/BoxTree';
import type { BoxTreeNodeComponentProps } from 'components/BoxTree/BoxTreeNodeComponentProps';
import { array, option, record } from 'fp-ts';
import { flow } from 'fp-ts/lib/function';
import { canvasGraphMessages } from 'pages/CanvasGraph/messages';
import type { FC } from 'react';
import { isObject } from 'utils/object/isObject';

interface DemoNode {
  text: string;
  children?: DemoNode[];
}

const objectToDemoNodes: (r: Record<string, unknown>) => DemoNode[] = flow(
  record.collect((key, value) => {
    let children: DemoNode[] | undefined;
    if (typeof value === 'string') {
      children = [{ text: value }];
    } else if (isObject(value)) {
      children = objectToDemoNodes(value);
    }
    return {
      text: key,
      children,
    };
  }),
  array.filter(isNonNullable),
);

const demoNodes = objectToDemoNodes(canvasGraphMessages.en);

const DemoBoxNode: FC<BoxTreeNodeComponentProps<DemoNode>> = ({ node }) => (
  <div
    style={{
      background: '#ffc',
      border: '1px solid #999',
      borderRadius: '4px',
      // add some stable randomized box heights
      minHeight: `${40 + 10 * (node.text.charCodeAt(0) % 5)}px`,
      padding: '6px 12px',
      whiteSpace: 'nowrap',
    }}
  >
    {node.text}
  </div>
);

const DemoBoxTree = makeBoxTree<DemoNode>({
  getChildren: flow(
    maybeProp('children'),
    option.getOrElse((): DemoNode[] => array.empty),
  ),
  nodeComponent: DemoBoxNode,
});

export const BoxTreeGallerySection: FC = () => (
  <div
    className='overflow-auto bg-white'
    style={{
      // stretch the component to available space
      flex: '1 0 0',
      padding: '20px',
    }}
  >
    <DemoBoxTree rootNodes={demoNodes} />
  </div>
);
